import ReputationProApiClient from "../../api/ReputationProApiClient";

const state = {};

const getters = {};

const actions = {
  async getSurveyResponse(context, campaignResponseId) {
    let client = new ReputationProApiClient();
    let response = await client.ProcessRequest(
      "GET",
      `/api/Campaign/response/${campaignResponseId}`
    );
    return response.data && response.data.successful && response.data.data
      ? response.data.data
      : null;
  },
  async getSurveyCampaigns(context, platformId) {
    let client = new ReputationProApiClient();
    const response = await client
      .ProcessRequest("GET", "/api/Campaign/dealer/" + platformId)
      .catch(error => error.response);
    return response;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Survey.js